export interface ParsedMenuItem {
  text: string;
  tooltip?: string;
}

export interface ParsedMessage {
  mainText: string;
  menuItems: ParsedMenuItem[];
}

/**
 * Extracts tooltip text from menu item if it contains "e.g."
 */
function extractTooltip(text: string): { text: string; tooltip?: string } {
  const tooltipMatch = text.match(/\s*\(e\.g\.,?\s*[^)]+\)\s*$/i);

  if (tooltipMatch) {
    return {
      text: text.substring(0, text.length - tooltipMatch[0].length).trim(),
      tooltip: tooltipMatch[0].trim(),
    };
  }

  return { text };
}

/**
 * Parses a chat message to extract menu items and main text.
 * Menu items are lines starting with '(+)'.
 */
export function parseMessage(text: string): ParsedMessage {
  const lines = text.split('\n');
  const menuItems: ParsedMenuItem[] = [];
  const mainTextLines: string[] = [];

  for (const line of lines) {
    const trimmed = line.trim();

    // Only recognize '(+)' as the menu item prefix
    if (trimmed.startsWith('(+)')) {
      const menuText = trimmed.substring(3).trim();
      if (menuText) {
        menuItems.push(extractTooltip(menuText));
      }
    } else {
      mainTextLines.push(line);
    }
  }

  return {
    mainText: mainTextLines.join('\n'),
    menuItems,
  };
}
